module.exports = __webpack_public_path__ + "static/media/store-alt.b08158d9.svg";